/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateEditVideoEditorEditsMutationRequest, WebAppCreateEditVideoEditorEditsMutationResponse, WebAppCreateEditVideoEditorEdits401, WebAppCreateEditVideoEditorEdits403 } from "../models/WebAppCreateEditVideoEditorEdits";

export function getWebAppCreateEditVideoEditorEditsUrl() {
  const res = { method: 'POST', url: `/web-app/v1/video-editor/edits` as const }
  return res
}

/**
 * @summary Create an edit from a source (response includes creator and published platforms)
 * {@link /web-app/v1/video-editor/edits}
 */
export async function webAppCreateEditVideoEditorEdits(data: WebAppCreateEditVideoEditorEditsMutationRequest, config: Partial<RequestConfig<WebAppCreateEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, WebAppCreateEditVideoEditorEditsMutationRequest>({ method : "POST", url : getWebAppCreateEditVideoEditorEditsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}